import {
  DEFAULT_LOGIN_REDIRECT_URL,
  ROOT_DOMAIN,
  ADDITIONAL_REDIRECT_HOSTS,
} from './constants';

function isAllowedRedirectTarget(
  url: URL,
  rootDomain = ROOT_DOMAIN,
  additionalHosts = ADDITIONAL_REDIRECT_HOSTS,
): boolean {
  if (url.protocol !== 'https:') {
    return false;
  }

  const hostname = (url.hostname || '').toLowerCase();
  const normalizedRootDomain = rootDomain.toLowerCase();
  const isRootDomain = hostname === normalizedRootDomain || hostname.endsWith('.' + normalizedRootDomain);
  return isRootDomain || additionalHosts.includes(hostname);
}

function getLocationState(propLocation, field, defaultValue = null) {
  let value;
  if (propLocation.state) {
    value = propLocation.state[field];
  }
  return value || defaultValue;
}

function redirectToNextUrl(nextUrl) {
  let url: URL;
  try {
    url = new URL(nextUrl, window.location.origin);
  } catch {
    redirectToMainApp();
    return;
  }

  if (!isAllowedRedirectTarget(url)) {
    // Fail closed without leaving an authenticated user stranded on login.
    // External integrations must add their exact host through
    // REACT_APP_ALLOWED_REDIRECT_HOSTS at build time.
    redirectToMainApp();
    return;
  }
  window.location.assign(url.toString());
}

function redirectToMainApp(subUrl='') {
  // add next behavior later..
  let url = DEFAULT_LOGIN_REDIRECT_URL;

  if (subUrl) {
    if (!subUrl.startsWith('/')) {
      subUrl = '/' + subUrl;
    }
    url += subUrl;
  }

  window.location.assign(url);
}

export { getLocationState, isAllowedRedirectTarget, redirectToMainApp, redirectToNextUrl };
